export const DAILY_LIMIT_TYPE_DAILY_AD_ACCOUNT_ONLY_COST = "DAILY_AD_ACCOUNT_ONLY_COST";
export const DAILY_LIMIT_TYPE_DAILY_AD_ACCOUNT_COST_AND_BUDGET = "DAILY_AD_ACCOUNT_COST_AND_BUDGET";
export const DAILY_LIMIT_TYPE_DAILY_CAMPAIGN_ONLY_BUDGET = "DAILY_LIMIT_TYPE_DAILY_CAMPAIGN_ONLY_BUDGET";
export const DAILY_LIMIT_TYPE_DAILY_CAMPAIGN_ONLY_COST = "DAILY_LIMIT_TYPE_DAILY_CAMPAIGN_ONLY_COST";
export const DAILY_LIMIT_TYPE_DAILY_CAMPAIGN_COST_AND_BUDGET = "DAILY_LIMIT_TYPE_DAILY_CAMPAIGN_COST_AND_BUDGET";

// Los que miran el PRESUPUESTO configurado. Espeja `check_budget` del backend
// (`AgencyClientAdAccount.DAILY_LIMIT_TYPE_DATA`) y decide, entre otras cosas, si tiene sentido
// mostrarle al usuario cuánto presupuesto hay cargado: bajo una alarma que vigila CONSUMO, ese dato
// habla de otra cosa y manda a revisar la pantalla equivocada.
export const DAILY_LIMIT_TYPES_WATCHING_BUDGET = [
    DAILY_LIMIT_TYPE_DAILY_AD_ACCOUNT_COST_AND_BUDGET,
    DAILY_LIMIT_TYPE_DAILY_CAMPAIGN_ONLY_BUDGET,
    DAILY_LIMIT_TYPE_DAILY_CAMPAIGN_COST_AND_BUDGET,
];

// Los que se evalúan campaña por campaña. Existe para que un test pueda RECORRERLOS y exigir que sus
// rótulos cortos no colisionen: son los que comparten la palabra «Campaña» en la columna del listado.
export const DAILY_LIMIT_TYPES_AT_CAMPAIGN_LEVEL = [
    DAILY_LIMIT_TYPE_DAILY_CAMPAIGN_ONLY_BUDGET,
    DAILY_LIMIT_TYPE_DAILY_CAMPAIGN_ONLY_COST,
    DAILY_LIMIT_TYPE_DAILY_CAMPAIGN_COST_AND_BUDGET,
];

// El sufijo de la clave i18n de cada tipo a nivel campaña, para renderizar la opción que
// corresponda. Vive PEGADO a la lista de arriba porque tiene que espejarla: un tipo en la lista sin
// entrada acá deja la clave en `client_ad_account_form_base.undefined`, y como i18next no tiene
// `parseMissingKeyHandler` configurado, eso se dibuja CRUDO en pantalla, sin error ni warning.
export const CAMPAIGN_OPTION_I18N_KEY = {
    [DAILY_LIMIT_TYPE_DAILY_CAMPAIGN_ONLY_BUDGET]: 'daily_limit_campaign',
    [DAILY_LIMIT_TYPE_DAILY_CAMPAIGN_ONLY_COST]: 'daily_limit_campaign_cost',
    [DAILY_LIMIT_TYPE_DAILY_CAMPAIGN_COST_AND_BUDGET]: 'daily_limit_campaign_cost_and_budget',
};

// Los rótulos cortos son lo único que se ve en la columna del listado (`[Campaña] ARS $16.000`).
// Desde que hay DOS tipos a nivel campaña, decir sólo "Campaña" no alcanza: son controles distintos
// —uno mira lo configurado, el otro lo gastado— y confundirlos manda a revisar la pantalla
// equivocada.
export const DAILY_LIMIT_TYPE_DATA = {
    [DAILY_LIMIT_TYPE_DAILY_AD_ACCOUNT_ONLY_COST]: {
        "Spanish": "Aplica sobre el consumo total de la cuenta", 
        "SpanishShort": "Cuenta",
        "English": "Applies to total account consumption",
        "EnglishShort": "Account"
    },
    [DAILY_LIMIT_TYPE_DAILY_AD_ACCOUNT_COST_AND_BUDGET]: {
        "Spanish": "Aplica sobre presupuesto y consumo total de la cuenta", 
        "SpanishShort": "Cuenta",
        "English": "Applies to budget and total account consumption",
        "EnglishShort": "Account"
    },
    [DAILY_LIMIT_TYPE_DAILY_CAMPAIGN_ONLY_BUDGET]: {
        "Spanish": "Presupuesto configurado en Campaña",
        "SpanishShort": "Campaña (presupuesto)",
        "English": "Budget configured in Campaign",
        "EnglishShort": "Campaign (budget)"
    },
    [DAILY_LIMIT_TYPE_DAILY_CAMPAIGN_ONLY_COST]: {
        "Spanish": "Consumo de cada Campaña",
        "SpanishShort": "Campaña (consumo)",
        "English": "Consumption of each Campaign",
        "EnglishShort": "Campaign (spend)"
    },
    [DAILY_LIMIT_TYPE_DAILY_CAMPAIGN_COST_AND_BUDGET]: {
        "Spanish": "Presupuesto y consumo de cada Campaña",
        "SpanishShort": "Campaña (ambos)",
        "English": "Budget and consumption of each Campaign",
        "EnglishShort": "Campaign (both)"
    },
};

// Utility function to get localized text based on current language
export const getLocalizedText = (data, language = 'es', key = 'Spanish') => {
    if (!data) return '';
    
    // Map language codes to dictionary keys
    const languageMap = {
        'es': 'Spanish',
        'en': 'English'
    };
    
    const languageKey = languageMap[language] || 'Spanish';
    return data[languageKey] || data['Spanish'] || '';
};

// Utility function to get localized short text
export const getLocalizedShortText = (data, language = 'es') => {
    if (!data) return '';
    
    const languageMap = {
        'es': 'SpanishShort',
        'en': 'EnglishShort'
    };
    
    const languageKey = languageMap[language] || 'SpanishShort';
    return data[languageKey] || data['SpanishShort'] || '';
};

/*
Usage Example in a React component:

import { DAILY_LIMIT_TYPE_DATA, getLocalizedText, getLocalizedShortText } from '../daily_limits';
import { withTranslation } from 'react-i18next';

class MyComponent extends Component {
    render() {
        const { i18n } = this.props;
        const limitType = 'DAILY_AD_ACCOUNT_ONLY_COST';
        
        // Get full description
        const fullText = getLocalizedText(DAILY_LIMIT_TYPE_DATA[limitType], i18n.language);
        
        // Get short description
        const shortText = getLocalizedShortText(DAILY_LIMIT_TYPE_DATA[limitType], i18n.language);
        
        return (
            <div>
                <p>{fullText}</p>
                <span>{shortText}</span>
            </div>
        );
    }
}

export default withTranslation()(MyComponent);
*/
